import Api from 'services/Api';

export function getUser(userId) {
  const query = `query Root($user_id: String!) {
        user(id: $user_id) {
          ... on ControlUser {
            email
            application {
              id
              secret
              name
              flavor
              project_code
              created_at
              account_id
            }
            account_roles {
              role
              account_id
              account {
                display_name
                applications {
                  slice {
                    id
                    secret
                    name
                    flavor
                    project_code
                    account_id
                    created_at
                  }
                }
              }
            }
          }
        }
      }`;

  const variables = {
    user_id: userId,
  };

  return Api.query(query, variables);
}
